<template>
    <branded-split-screen
        heading="Forgot your password?"
        description="No worries — we'll send you a link to get back into your account in no time."
    >
        <h2 class="text-2xl font-semibold text-taupe-900 dark:text-taupe-50">
            Forgot password?
        </h2>
        <p class="mt-1 text-sm text-taupe-500 dark:text-taupe-400">
            Or
            <router-link
                :to="{ name: 'LoginScreen' }"
                class="font-medium text-sky-500 dark:text-sky-400 hover:text-sky-600 dark:hover:text-sky-300"
                >login to an existing account!</router-link
            >
        </p>

        <div v-if="success" class="mt-8 space-y-4">
            <h3 class="text-xl font-medium text-taupe-900 dark:text-taupe-50">
                Check your email
            </h3>
            <p class="text-taupe-600 dark:text-taupe-300">
                Thanks! If <strong>{{ form.email }}</strong> matches an email we
                have on file, then we've sent you an email containing further
                instructions for resetting your password.
            </p>
            <p class="text-taupe-600 dark:text-taupe-300">
                If you haven't received an email in 5 minutes, check your spam
                or try a different email.
            </p>
        </div>
        <form
            v-if="!success"
            @submit.prevent="submit"
            @keydown.enter="submitFormOnEnter"
            class="mt-8 space-y-6"
        >
            <zen-message-block v-if="message" type="error">
                {{ message }}
            </zen-message-block>

            <div>
                <label
                    for="email"
                    class="block font-medium text-taupe-800 dark:text-taupe-100"
                >
                    Email address
                </label>
                <div class="mt-1">
                    <input
                        id="email"
                        name="email"
                        type="email"
                        autocomplete="email"
                        required
                        v-model="form.email"
                        class="appearance-none block w-full px-3 py-2 border border-taupe-300 rounded-md shadow-xs placeholder-taupe-400 dark:placeholder-taupe-500 focus:outline-hidden focus:ring-sky-500 focus:border-sky-500 dark:border-taupe-600 dark:bg-taupe-800 dark:text-taupe-50"
                    />
                </div>
            </div>

            <div>
                <zen-button
                    type="submit"
                    variant="primary"
                    size="large"
                    full-width
                    :processing="loading"
                >
                    Forgot Password
                </zen-button>
            </div>
        </form>
    </branded-split-screen>
</template>

<script>
import BrandedSplitScreen from '@/screens/_components/BrandedSplitScreen.vue'
import AuthPasswordService from '@/services/auth.password.service'
import { submitFormOnEnter } from '@/utils/form-submit'

export default {
    components: {
        BrandedSplitScreen,
    },
    data() {
        return {
            form: {
                email: '',
            },
            loading: false,
            success: false,
            message: '',
        }
    },
    methods: {
        submitFormOnEnter,
        submit() {
            this.loading = true
            AuthPasswordService.create(this.form).then(
                () => {
                    this.success = true
                    this.loading = false
                },
                (error) => {
                    this.loading = false
                    this.message = error
                }
            )
        },
    },
}
</script>
